// extracted by mini-css-extract-plugin
export default {"custom-select":"PopupSolution_custom-select__Leg3Q","header-select":"PopupSolution_header-select__CMqaM"};